import { render } from "./CommonSelect.vue?vue&type=template&id=2f8c806a"
import script from "./CommonSelect.vue?vue&type=script&lang=js"
export * from "./CommonSelect.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./CommonSelect.vue?vue&type=style&index=0&id=2f8c806a&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__